// Numer kolejnego dokumentu wyliczony z numeru najnowszego: zwiększamy część
// liczbową i zachowujemy sufiks, więc "37/2026" daje "38/2026", a "112" -> "113".
const nextDocumentNr = (lastNr) => {
  const match = String(lastNr || "").match(/^(\d+)(.*)$/);

  return match ? String(parseInt(match[1], 10) + 1) + match[2] : "";
};

export default nextDocumentNr;
